import { useTheme } from "next-themes";
import { useLayoutEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { setIsComplexDesktop, setIsComplexPortrait, setIsReady, setPlayerParams } from "../../redux/slices/videoDataSlice";
import { conditions } from "../conditions/conditions";
import { ConditionName } from "../../interfaces/enums";
import { getUUID, handleIsComplexPortrait, staticFormats, strToObj } from "../helpers";
import { handleVoucherInParams } from "../../redux/actions/user.actions";
import { shallowEqual } from 'react-redux'

const useHandleParams = (query: any) => {
    const { token, params } = useAppSelector(({ videoData: { token, params } }) => ({ token, params }), shallowEqual);
    const { isClickInnerCard } = useAppSelector(({ controller: { isClickInnerCard } }) => ({ isClickInnerCard }), shallowEqual);
    const { setTheme } = useTheme();
    const dispatch = useAppDispatch();

    const handleTokenParams = async () => {

        if (query.isAuth === "true") {
            if (token) dispatch(setIsReady(true));
        } else if (query.voucher === "true") {
            handleVoucherInParams(query.voucherCode!);
            dispatch(setIsReady(true));
        } else {
            dispatch(setIsReady(true));
        }
    }

    const handleTheme = (queryParams:any) => {
        if (query.theme) {
            const theme = query.theme === "light" ? "light" : "dark"
            setTheme(theme);
            dispatch(setPlayerParams({ ...queryParams, theme: theme }))
        }
        else {
            if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                setTheme("dark");
                dispatch(setPlayerParams({ ...queryParams, theme: "dark" }))
            }
            else {
                setTheme("light");
                dispatch(setPlayerParams({ ...queryParams, theme: "light" }));
            }
        }
    }

    const handleFeatureSet = (queryParams:any) => {
        let featureSet = queryParams.featureSet;
        if(typeof queryParams.featureSet === "string") featureSet = strToObj(queryParams.featureSet);
        queryParams.featureSet = featureSet;
        return queryParams;
    }

    const handleAddUUID = (queryParams:any) => {
        if (!!query.uuid) {
            localStorage.setItem("hamrahiUUID", query.uuid!);
            queryParams.uuid = query.uuid;
        }
        return queryParams;
    }

    const handleLiveAndVodParams = (queryParams: any) => {
        queryParams = {
            portrait: (conditions(ConditionName.isTouchScreen) && !conditions(ConditionName.isSplusEnvironment) && query.isGeneral !== "true") ? "true" : "false",
            provider: "unknown",
            chart: "true",
            authentication: "true",
            ...query
        }
        dispatch(setIsComplexDesktop(queryParams.portrait === "true" && !conditions(ConditionName.isTouchScreen)));
        dispatch(setIsComplexPortrait(handleIsComplexPortrait({ portrait: queryParams.portrait, ...query })));
        return queryParams;
    }

    const handleStaticParams = (queryParams: any) => {

        const eUrl = String(query["e-url"]);
        const eCover = String(query["e-cover"]);
        queryParams = {
            src: eUrl.endsWith("/") ? window.atob(eUrl.slice(0, -1)) : window.atob(eUrl),
            type: query.type,
            fullscreen: query.fullscreen,
            autoplay: query.autoplay,
            snapshot: query.snapshot,
            portrait: false,
            ad: query.ad,
            fullrate: query.fullrate,
            width: query.width,
            height: query.height,
            cover: (!!eCover && eCover !== "undefined") ? window.atob(eCover) : undefined,
            onFinished: query.onFinished,
            onSnapshot: query.onSnapshot,
            uuid: getUUID()
        }
        return queryParams;
    }

    useLayoutEffect(() => {
        if (params.id && query.quiz !== "true" && isClickInnerCard) query = { ...params, homeButtonClickFlag: query.homeButtonClickFlag };
        (async () => {
            let queryParams;
            if (Object.keys(query).includes("type")) {
                if (["live", "vod", "archive", "clip"].includes(String(query.type))) queryParams = handleLiveAndVodParams(queryParams);
                else if (staticFormats(String(query.type))) queryParams = handleStaticParams(queryParams);
                handleAddUUID(queryParams);
                handleFeatureSet(queryParams);
                handleTheme(queryParams);
                handleTokenParams();
            }
        })()
    }, [query, token, params.id, isClickInnerCard])
}

export default useHandleParams;